const DB_NAME = "barnyard-offline";
const STORE = "blobs";
const VERSION = 1;

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("Could not open offline storage."));
  });
}

function req<T>(request: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("Offline storage failed."));
  });
}

/** Persist image bytes for offline receipt capture until scan/upload can run. */
export async function putOfflineBlob(id: string, blob: Blob): Promise<void> {
  const db = await openDb();
  try {
    await req(db.transaction(STORE, "readwrite").objectStore(STORE).put(blob, id));
  } finally {
    db.close();
  }
}

export async function getOfflineBlob(id: string): Promise<Blob | undefined> {
  const db = await openDb();
  try {
    return await req(db.transaction(STORE, "readonly").objectStore(STORE).get(id));
  } finally {
    db.close();
  }
}

export async function deleteOfflineBlob(id: string): Promise<void> {
  const db = await openDb();
  try {
    await req(db.transaction(STORE, "readwrite").objectStore(STORE).delete(id));
  } finally {
    db.close();
  }
}

export async function deleteOfflineBlobs(ids: string[]): Promise<void> {
  await Promise.all(ids.map((id) => deleteOfflineBlob(id)));
}
